import button from '@salesforce/retail-react-app/app/theme/components/base/button'

const pickupCtaBase = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '30px',
    minWidth: '149px',
    paddingX: '16px',
    textTransform: 'uppercase',
    fontSize: '9px',
    fontWeight: '700',
    fontFamily: 'body',
    lineHeight: '20px',
    letterSpacing: '1.2px',
    borderRadius: '90px',
    transition: 'background-color .15s ease'
}

export default {
    ...button,
    variants: {
        ...button.variants,
        solid: (props) => ({
            ...button.variants.solid(props),
            backgroundColor: props.isDisabled
                ? 'gray.40'
                : props.brand === 'ks'
                ? 'teal.500'
                : 'black.300',
            borderRadius: '90px',
            borderColor: props.isDisabled ? 'transparent' : 'black.100',
            border: props.isDisabled ? 'none !important' : '1px solid',
            color: props.isDisabled ? 'gray.650' : 'white',
            fontFamily: 'body',
            fontWeight: '400',
            _hover: {
                bg: {
                    base: props.brand === 'ks' ? 'teal.500' : 'black.300',
                    lg: props.brand === 'ks' ? 'teal.400' : 'black.50'
                },
                textDecoration: 'none',
                _disabled: {bg: 'gray.40'}
            },
            _active: {bg: props.brand === 'ks' ? 'teal.400' : 'black.50'},
            _disabled: {bg: 'gray.40', border: 'none !important', color: 'gray.650', opacity: 1},
            transition: 'background-color .15s ease'
        }),
        outline: (props) => ({
            ...button.variants.outline(props),
            borderRadius: '3px',
            fontFamily: 'body',
            borderColor: 'purple.75',
            fontWeight: '400',
            color: 'black.100',
            _hover: {
                _disabled: {bg: 'gray.40'}
            },
            _disabled: {
                bg: 'gray.40',
                border: 'none !important',
                color: 'gray.650 !important',
                opacity: 1
            }
        }),
        link: () => ({
            color: 'teal.600',
            fontWeight: '300',
            minWidth: '1em',
            lineHeight: 4
        }),
        icon: {
            backgroundColor: 'white',
            padding: 0,
            height: 'auto',
            width: 'auto',
            minWidth: '42px',
            minHeight: '42px',
            borderRadius: '4px',
            _hover: {
                backgroundColor: 'gray.50'
            }
        },
        heroButton: {
            fontWeight: '400',
            fontFamily: 'body',
            transition: 'all 0.3s ease',
            textAlign: 'center',
            _hover: {
                textDecoration: 'none',
                bg: 'teal.600'
            }
        },
        buttonDark: (props) => ({
            color: 'white',
            backgroundColor: props.brand === 'ks' ? 'teal.500' : 'black.300',
            fontWeight: '400',
            fontFamily: 'body',
            transition: 'all 0.3s ease',
            textAlign: 'center',
            _hover: {
                textDecoration: 'none',
                backgroundColor: props.brand === 'ks' ? 'teal.400' : 'black.50',
                color: 'white'
            },
            _active: {
                backgroundColor: props.brand === 'ks' ? 'teal.400' : 'black.50',
                color: 'white'
            },
            _focus: {
                backgroundColor: props.brand === 'ks' ? 'teal.400' : 'black.50',
                color: 'white'
            }
        }),
        // Find My Store modal CTAs
        pickupSelectStore: {
            ...pickupCtaBase,
            bg: 'black.100',
            color: 'white',
            _hover: {bg: 'black.50', textDecoration: 'none'},
            _active: {bg: 'black.50'}
        },
        pickupYourStore: {
            ...pickupCtaBase,
            bg: 'white',
            color: 'black.300',
            border: '1px solid',
            borderColor: 'black.300',
            _hover: {
                bg: 'white',
                textDecoration: 'none',
                _disabled: {
                    bg: 'white',
                    color: 'black.300',
                    borderColor: 'black.300',
                    opacity: 1
                }
            },
            _active: {bg: 'white'},
            _disabled: {
                bg: 'white',
                color: 'black.300',
                border: '1px solid',
                borderColor: 'black.300',
                opacity: 1
            }
        },
        pickupUnavailable: {
            ...pickupCtaBase,
            bg: 'gray.600',
            color: 'white',
            _hover: {
                bg: 'gray.600',
                textDecoration: 'none',
                _disabled: {
                    bg: 'gray.600',
                    color: 'white',
                    opacity: 1
                }
            },
            _active: {bg: 'gray.600'},
            _disabled: {
                bg: 'gray.600',
                color: 'white',
                opacity: 1
            }
        },
        linkUnderline: {
            fontSize: '17px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            textDecoration: 'underline',
            padding: 0,
            width: 'auto',
            minWidth: 'auto',
            height: 'auto',
            minHeight: 'auto',
            _hover: {
                textDecoration: 'none'
            }
        },
        storyComponentLink: {
            fontSize: '17px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '26px',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            display: 'flex',
            padding: '0',
            justifyContent: 'space-between',
            gap: '15px',
            _hover: {
                '& img': {
                    transform: 'translateX(100%)'
                }
            },
            width: 'fit-content'
        },
        buttonOutline: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '56px',
            height: 'auto',
            paddingX: '50px',
            width: 'auto',
            background: 'white',
            color: 'black.100',
            fontSize: '17px',
            fontWeight: '400',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            borderRadius: '28px',
            border: '1px solid',
            borderColor: 'black.300',
            _hover: {
                textDecoration: 'none'
            }
        },
        button: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '56px',
            height: 'auto',
            paddingX: {base: '25px', md: '50px'},
            width: 'auto',
            background: 'black',
            color: 'white',
            fontSize: '17px',
            fontWeight: '400',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            borderRadius: '28px',
            _hover: {
                textDecoration: 'none',
                _disabled: {
                    backgroundColor: 'gray.40',
                    color: 'gray.650',
                    opacity: 1
                }
            },
            _disabled: {
                backgroundColor: 'gray.40',
                color: 'gray.650',
                opacity: 1
            },
            transition: 'background-color .15s ease'
        },
        buttonSmall: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '30px',
            height: 'auto',
            paddingX: '25px',
            width: 'auto',
            background: 'black',
            color: 'white',
            fontSize: '14px',
            fontWeight: '400',
            fontFamily: 'body',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            borderRadius: '15px',
            _hover: {
                textDecoration: 'none'
            },
            transition: 'background-color .15s ease'
        },
        textWithArrow: {
            fontSize: '17px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            backgroundColor: 'transparent',
            color: 'black.100',
            height: 'auto',
            border: 'none',
            borderRadius: '0',
            padding: 0,
            _hover: {
                textDecoration: 'none',
                '.button__arrow-icon': {
                    transform: 'translateX(5px)'
                }
            }
        },
        textUnderline: {
            fontSize: '17px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            backgroundColor: 'transparent',
            color: 'black.100',
            height: 'auto',
            border: 'none',
            borderRadius: '0',
            padding: 0,
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            _hover: {
                color: 'blue.700'
            }
        },
        dropdown: {
            fontSize: '17px',
            fontWeight: '300',
            fontFamily: 'body',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            backgroundColor: 'white',
            color: 'black.100',
            minHeight: '56px',
            height: 'auto',
            border: 'none',
            borderRadius: '0',
            paddingY: 0,
            paddingX: '10px',
            _hover: {
                textDecoration: 'none',
                '.button__arrow-icon': {
                    transform: 'translateX(5px)'
                }
            }
        }
    },
    sizes: {
        small: {
            fontSize: '14px',
            height: '30px',
            borderRadius: '15px',
            width: 'auto',
            minWidth: {base: 'auto', md: '185px'},
            padding: {
                base: '15px 15px',
                md: '15px 50px'
            },
            transition: 'background-color .15s ease'
        },
        normal: {
            fontSize: '17px',
            height: '56px',
            borderRadius: '28px',
            width: {base: '100%', md: 'auto'},
            minWidth: {base: 'auto', md: '354px'},
            padding: {base: '4px 25px', md: '4px 50px'},
            transition: 'background-color .15s ease'
        }
    }
}
